/**
 * useAnalyticsHints
 *
 * Manages the "Show analytics hints" preference — the small info-icon
 * tooltips that explain each metric tile on the Analytics page.
 *
 * Stored in localStorage as `ss_analytics_hints`:
 *   null / missing → default ON (first-time users see hints)
 *   '1'            → ON
 *   '0'            → OFF
 */

import { useState, useCallback } from 'react';

const LS_KEY = 'ss_analytics_hints';

function readLS(): boolean {
  try {
    const v = localStorage.getItem(LS_KEY);
    return v === null ? true : v === '1'; // default ON
  } catch {
    return true;
  }
}

export function useAnalyticsHints() {
  const [hintsEnabled, setHintsEnabled] = useState<boolean>(readLS);

  const setHints = useCallback((enabled: boolean) => {
    try {
      localStorage.setItem(LS_KEY, enabled ? '1' : '0');
    } catch { /* ignore */ }
    setHintsEnabled(enabled);
  }, []);

  return { hintsEnabled, setHints };
}
